import WorkflowService from '~/scripts/services/workflow.service';

/**
 * @param {import('angular').auto.IInjectorService} $injector
 * @param {any} $scope
 * @param {import('angular').ITimeoutService} $timeout
 */
export default /* @ngInject */ (
	$injector,
	$scope,
	$timeout,
) => {
	const workflowService = new WorkflowService($injector);

	$scope.showAddWorkflow = false;
	$scope.options = {
		checkBox:     false,
		history:      false,
		id:           'open',
		list:         'ALL',
		openWf:       false,
		showAdd:      $scope.showAddWorkflow && !$scope.readOnly,
		subscription: false,
	};
	$scope.formActionsOptions = {
		component: true,
		hideHistory: true,
	};
	$scope.wfNodeSelectOptions = {};

	if ($scope.form?.kid) {
		$timeout(async () => {
			$scope.affectList = await workflowService.nodeAffectList($scope.form.kid, $scope.options.id);
			$scope.$apply();
		});
	}
};
